import { useState, useEffect } from 'react';
import { api } from '../api';
import TabCheques from './TabCheques';

const TABS = [
  { key: 'top',       label: '🏆 Top Clientes',   color: '#ffc107' },
  { key: 'frecuentes',label: '🔄 Frecuentes',      color: '#4cc9f0' },
  { key: 'perdidos',  label: '👻 Perdidos',         color: '#e63946' },
  { key: 'nuevos',    label: '🌟 Nuevos',           color: '#4caf50' },
];

export default function Clientes() {
  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [tab, setTab] = useState('top');
  const [busqueda, setBusqueda] = useState('');
  const [tabPrincipal, setTabPrincipal] = useState('clientes');

  useEffect(() => { cargar(); }, []);

  const cargar = async () => {
    setCargando(true);
    try {
      const data = await api.get('/clientes');
      setDatos(data.error ? null : data);
    } catch (e) { console.error(e); }
    finally { setCargando(false); }
  };

  const clientes = datos?.[tab] || [];
  const clientesFiltrados = clientes.filter(c =>
    c.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
    c.cedula.includes(busqueda) ||
    c.telefono.includes(busqueda)
  );

  const tabActual = TABS.find(t => t.key === tab);

  if (cargando) return <p style={s.cargando}>Analizando clientes...</p>;
  if (!datos) return <p style={{ color: '#e63946' }}>No se pudo cargar</p>;

  return (
    <div>

      {/* ── Selector principal ── */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        {[
          { key: 'clientes', label: '👥 Clientes' },
          { key: 'cheques',  label: '🧾 Cheques'  },
        ].map(t => (
          <button key={t.key} onClick={() => setTabPrincipal(t.key)}
            style={{
              padding: '8px 22px', borderRadius: 8, cursor: 'pointer',
              fontSize: 13, fontWeight: 'bold',
              background: tabPrincipal === t.key ? '#1a2a3e' : 'none',
              border: tabPrincipal === t.key ? '1px solid #4cc9f0' : '1px solid #2d2d44',
              color: tabPrincipal === t.key ? '#4cc9f0' : '#888',
            }}>
            {t.label}
          </button>
        ))}
      </div>

      {/* ── TAB: CLIENTES ── */}
      {tabPrincipal === 'clientes' && (
        <div>
          {/* Header */}
          <div style={s.headerRow}>
            <div>
              <h2 style={s.titulo}>👥 Clientes</h2>
              <p style={s.subtitulo}>{datos.total_clientes} clientes analizados · últimos 2 años</p>
            </div>
            <button style={s.botonRefresh} onClick={cargar}>🔄 Actualizar</button>
          </div>

          {/* KPIs */}
          <div style={s.kpisRow}>
            {TABS.map(t => (
              <div key={t.key} style={{...s.kpiCard, borderTopColor: t.color, cursor: 'pointer'}}
                onClick={() => { setTab(t.key); setBusqueda(''); }}>
                <div style={{...s.kpiValor, color: t.color}}>{datos[t.key]?.length || 0}</div>
                <div style={s.kpiLabel}>{t.label}</div>
              </div>
            ))}
          </div>

          {/* Tabs */}
          <div style={s.tabs}>
            {TABS.map(t => (
              <button key={t.key}
                style={{...s.tab, ...(tab === t.key ? {...s.tabActivo, borderBottomColor: t.color} : {})}}
                onClick={() => { setTab(t.key); setBusqueda(''); }}>
                {t.label}
              </button>
            ))}
          </div>

          {/* Contenido */}
          <div style={s.contenido}>
            {/* Buscador */}
            <input style={s.inputBusqueda} value={busqueda}
              onChange={e => setBusqueda(e.target.value)}
              placeholder="Buscar por nombre, cédula o teléfono..." />

            {/* Descripción del segmento */}
            <div style={s.segmentoInfo}>
              {tab === 'top'       && <span>Top 20 clientes por revenue total en los últimos 2 años</span>}
              {tab === 'frecuentes'&& <span>Clientes con 3+ visitas en los últimos 90 días</span>}
              {tab === 'perdidos'  && <span>Clientes sin visita en más de 90 días · ordenados por valor histórico</span>}
              {tab === 'nuevos'    && <span>Clientes con máximo 2 visitas en los últimos 30 días</span>}
            </div>

            {/* Tabla */}
            <div style={s.tabla}>
              <div style={s.tablaHeader}>
                <span style={{ flex: 3 }}>CLIENTE</span>
                <span style={{ flex: 1 }}>CÉDULA</span>
                <span style={{ flex: 1 }}>TELÉFONO</span>
                {tab === 'top' && <>
                  <span style={{ width: 70,  textAlign: 'center' }}>VISITAS</span>
                  <span style={{ width: 110, textAlign: 'right'  }}>REVENUE</span>
                  <span style={{ width: 90,  textAlign: 'right'  }}>TICKET PROM.</span>
                </>}
                {tab === 'frecuentes' && <>
                  <span style={{ width: 90,  textAlign: 'center' }}>VISITAS 90d</span>
                  <span style={{ width: 110, textAlign: 'right'  }}>REVENUE 90d</span>
                </>}
                {tab === 'perdidos' && <>
                  <span style={{ width: 100, textAlign: 'center' }}>DÍAS AUSENTE</span>
                  <span style={{ width: 110, textAlign: 'right'  }}>ÚLTIMA VISITA</span>
                  <span style={{ width: 100, textAlign: 'right'  }}>REVENUE HIST.</span>
                </>}
                {tab === 'nuevos' && <>
                  <span style={{ width: 120, textAlign: 'center' }}>PRIMERA VISITA</span>
                  <span style={{ width: 70,  textAlign: 'center' }}>VISITAS</span>
                  <span style={{ width: 100, textAlign: 'right'  }}>REVENUE</span>
                </>}
              </div>

              {clientesFiltrados.length === 0 ? (
                <div style={{ padding: 40, textAlign: 'center', color: '#555' }}>Sin resultados</div>
              ) : clientesFiltrados.map((c, i) => (
                <div key={i} style={{...s.tablaRow, background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}}
                  onMouseEnter={e => e.currentTarget.style.background = '#2d2d44'}
                  onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}>
                  <span style={{ flex: 3 }}>
                    <div style={{ color: '#fff', fontSize: 13, fontWeight: '600' }}>{c.nombre}</div>
                  </span>
                  <span style={{ flex: 1, color: '#555', fontSize: 12 }}>{c.cedula}</span>
                  <span style={{ flex: 1, color: '#aaa', fontSize: 12 }}>{c.telefono || '—'}</span>

                  {tab === 'top' && <>
                    <span style={{ width: 70, textAlign: 'center', color: '#fff', fontWeight: 'bold' }}>{c.total_visitas}</span>
                    <span style={{ width: 110, textAlign: 'right', color: '#ffc107', fontWeight: 'bold' }}>${c.revenue_neto.toFixed(2)}</span>
                    <span style={{ width: 90, textAlign: 'right', color: '#aaa', fontSize: 12 }}>${c.ticket_promedio.toFixed(2)}</span>
                  </>}

                  {tab === 'frecuentes' && <>
                    <span style={{ width: 90, textAlign: 'center' }}>
                      <span style={{ background: '#1a3a4a', color: '#4cc9f0', borderRadius: 6, padding: '3px 10px', fontWeight: 'bold' }}>
                        {c.visitas_90d}x
                      </span>
                    </span>
                    <span style={{ width: 110, textAlign: 'right', color: '#4cc9f0', fontWeight: 'bold' }}>${c.revenue_90d.toFixed(2)}</span>
                  </>}

                  {tab === 'perdidos' && <>
                    <span style={{ width: 100, textAlign: 'center' }}>
                      <span style={{
                        background: c.dias_ausente > 180 ? '#3a1a1a' : '#3a2a1a',
                        color:      c.dias_ausente > 180 ? '#e63946'  : '#ff9800',
                        borderRadius: 6, padding: '3px 10px', fontWeight: 'bold', fontSize: 12,
                      }}>
                        {c.dias_ausente}d
                      </span>
                    </span>
                    <span style={{ width: 110, textAlign: 'right', color: '#aaa', fontSize: 12 }}>{c.ultima_visita}</span>
                    <span style={{ width: 100, textAlign: 'right', color: '#e63946', fontWeight: 'bold' }}>${c.revenue_neto.toFixed(2)}</span>
                  </>}

                  {tab === 'nuevos' && <>
                    <span style={{ width: 120, textAlign: 'center', color: '#4caf50', fontSize: 12 }}>{c.primera_visita}</span>
                    <span style={{ width: 70, textAlign: 'center', color: '#fff', fontWeight: 'bold' }}>{c.total_visitas}</span>
                    <span style={{ width: 100, textAlign: 'right', color: '#4caf50', fontWeight: 'bold' }}>${c.revenue_neto.toFixed(2)}</span>
                  </>}
                </div>
              ))}
            </div>

            {/* Total revenue del segmento */}
            {tab === 'top' && (
              <div style={s.totalRow}>
                <span style={{ color: '#aaa', fontSize: 13 }}>Revenue total Top 20:</span>
                <span style={{ color: '#ffc107', fontWeight: 'bold', fontSize: 16, marginLeft: 12 }}>
                  ${clientesFiltrados.reduce((a, c) => a + c.revenue_neto, 0).toFixed(2)}
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── TAB: CHEQUES ── */}
      {tabPrincipal === 'cheques' && <TabCheques />}

    </div>
  );
}

const s = {
  cargando:      { color: '#aaa', padding: 40, textAlign: 'center' },
  headerRow:     { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 },
  titulo:        { color: '#fff', marginBottom: 4 },
  subtitulo:     { color: '#555', fontSize: 13 },
  botonRefresh:  { background: 'none', border: '1px solid #444', borderRadius: 8, color: '#aaa', padding: '8px 16px', cursor: 'pointer', fontSize: 13 },
  kpisRow:       { display: 'flex', gap: 16, marginBottom: 24 },
  kpiCard:       { background: '#1e1e2e', borderRadius: 12, padding: 20, flex: 1, borderTop: '3px solid #7209b7' },
  kpiValor:      { color: '#fff', fontSize: 28, fontWeight: 'bold', marginBottom: 4 },
  kpiLabel:      { color: '#aaa', fontSize: 12 },
  tabs:          { display: 'flex', gap: 4, borderBottom: '1px solid #2d2d44' },
  tab:           { background: 'none', border: 'none', borderBottom: '2px solid transparent', color: '#888', padding: '12px 20px', cursor: 'pointer', fontSize: 13 },
  tabActivo:     { color: '#fff', fontWeight: 'bold' },
  contenido:     { background: '#1e1e2e', borderRadius: '0 0 12px 12px', padding: 24, minHeight: 300 },
  inputBusqueda: { width: '100%', background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 8, color: '#fff', padding: '10px 14px', fontSize: 13, marginBottom: 12, boxSizing: 'border-box' },
  segmentoInfo:  { color: '#555', fontSize: 12, marginBottom: 16 },
  tabla:         { borderRadius: 8, overflow: 'hidden' },
  tablaHeader:   { display: 'flex', padding: '10px 16px', background: '#0f0f1a', color: '#555', fontSize: 11, fontWeight: 'bold', gap: 8 },
  tablaRow:      { display: 'flex', padding: '12px 16px', gap: 8, alignItems: 'center', transition: 'background 0.15s', cursor: 'default' },
  totalRow:      { display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '16px 16px 0', borderTop: '1px solid #2d2d44', marginTop: 8 },
};